import { Component, Vue } from 'vue-property-decorator';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import RefCardItem from '@/shared/cards/briefing/ref-card-item/ref-card-item.vue';

let oneDriveAccessToken: string | null = null;

@Component({
  components: {
    'ref-item': RefCardItem,
    vueCustomScrollbar: vueCustomScrollbar,
  },
})
export default class CloudSigninComponent extends Vue {
  openOneDrivePopup() {
    const clientId = 'ef822439-6ec7-4372-90c8-49079b072324'; // Thay bằng OneDrive Client ID của bạn
    const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=token&scope=Files.ReadWrite User.Read&redirect_uri=http://localhost`;

    const popup = window.open(authUrl, '_blank', 'width=500,height=600');

    const interval = setInterval(() => {
      if (!popup || popup.closed) {
        clearInterval(interval);
        return;
      }
      const hashParams = new URLSearchParams(popup.location.hash.substring(1));
      const token = hashParams.get('access_token');

      if (token) {
        oneDriveAccessToken = token;
        console.log('OneDrive Token:', oneDriveAccessToken);
        popup.close();
        this.fetchAndEmitOneDriveUserInfo(oneDriveAccessToken);
        clearInterval(interval);
      }
    }, 1000);
  }

  async fetchAndEmitOneDriveUserInfo(token: string) {
    try {
      const response = await fetch('https://graph.microsoft.com/v1.0/me', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const userInfo = await response.json();
      console.log('OneDrive User Info:', userInfo);
      this.$emit('onedrive-token', token, userInfo);
    } catch (error) {
      console.error('Error fetching OneDrive user info:', error);
    }
  }
}
